import { useCallback } from "react";

import { openNewRuleFlow } from "@/app/app/_/commands/utils";
import { RuleFragment } from "@/__generated__/graphql";
import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

export function RuleListTab() {
  const {
    columns,
    rows,
    loading,
    totalCount,
    loadNext,
    networkStatus,
    deleteNodeButtonProps,
  } = useConnectionSetup<RuleFragment>({
    appView: "rules",
    fetchPolicy: "network-only",
  });

  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  const handleAddNew = useCallback(() => {
    openNewRuleFlow();
  }, []);

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={rows}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      placeholderRow={Objects.RuleDefinitionObject.placeholder}
      onAddNew={handleAddNew}
    />
  );
}
